<!--详情页面-->
<template>
    <div ref="print1" style="width: 100%;margin: 0 auto;">
      <p :style="{textAlign:'center',fontSize:'18px',lineHeight:'40px'}">{{pagetitle.indexOf(';')!=-1?pagetitle.split(';')[0]:pagetitle}}</p>
      <!--<div v-if="controlData.isjiaji==1" style="color:red;margin-left: 20px;font-weight:bold;float:left ">-->
        <!--<span>加急！！</span>（{{controlData.wantarrivaltime}}）-->
      <!--</div>-->
      <div style="margin: 0 auto;text-align: right;"><img :src="imgpath"/></div>
      <table cellspacing="0" cellpadding="0" border="0" style="border-collapse:collapse;width:100%;" class="print-table" v-if="issimple">
        <tr class="noborder" style="height: 26px">
          <td align="right" width="60">订单号：</td>
          <td >{{controlData.erpserial}}</td>
        </tr>
        <tr class="noborder" style="height: 26px">
          <td align="right">门&nbsp;&nbsp;店：</td>
          <td>{{controlData.customername}}</td>
        </tr>
        <tr class="noborder" style="height: 26px">
          <td align="right">时&nbsp;&nbsp;间：</td>
          <td>{{controlData.ssfzr||''}} {{controlData.htqd||controlData.adddate}}</td>
        </tr>
        <tr class="noborder" style="height: 26px">
          <td align="right">加工项：</td>
          <td><span style="color: red;font-size: larger"><b>{{seedname}}&nbsp;&nbsp;x{{sumnumber}}</b> </span><span style="color: red;font-size: larger" v-if="false&&(printDisplay||!isprint)"><b>、 {{summoney}}元</b></span></td>
        </tr>
        <tr v-if="chufangdan"><td colspan="2"><RLTable ref="RLTable1" :isview="true" :chufangdan="chufangdan"></RLTable></td></tr>
        <tr class="noborder" v-if="showremark">
          <td align="right">说&nbsp;&nbsp;明：</td>
          <td colspan="5" style="border: none;height: 30px">
            <div v-html="getLiuYan(controlData.remark)"></div>
          </td>
        </tr>
      </table>
      <table cellspacing="0" cellpadding="0" border="0" style="border-collapse:collapse;width:100%;" class="print-table" v-else>
        <tr class="noborder" style="height: 26px">
          <td align="right" width="60">订单号：</td>
          <td width="140">{{controlData.erpserial}}</td>
          <td align="right" width="60"><span v-if="controlData.pcustomer==controlData.servedname||!isprint">门&nbsp;&nbsp;店：</span></td>
          <td><span style="font-size: larger"><b v-if="controlData.pcustomer==controlData.servedname||!isprint">{{controlData.customername}}</b></span></td>
          <td align="right" width="60"></td>
          <td width="200"></td>
        </tr>
        <tr class="noborder" style="height: 26px" v-if="controlData.pcustomer==controlData.servedname||!isprint">
          <td align="right">时&nbsp;&nbsp;间：</td>
          <td>{{controlData.htqd||controlData.adddate}}</td>
          <td align="right">地&nbsp;&nbsp;址：</td>
          <td>{{controlData.deliveryaddress}}</td>
          <td align="right">联系人：</td>
          <td>{{(controlData.linkman||"")+" " +((controlData.linkmantel&&controlData.linkmantel!='null')?controlData.linkmantel:'')}}</td>
        </tr>
        <tr class="noborder" style="height: 26px" v-if="controlData.pcustomer!=controlData.servedname">
          <td align="right">加工点：</td>
          <td>{{controlData.pcustomer}}</td>
          <td align="right">地&nbsp;&nbsp;址：</td>
          <td>{{controlData.caddress}}</td>
          <td align="right">联系人：</td>
          <td>{{(controlData.clinkman||"")+" " +(controlData.clinkmantel||"")}}</td>
        </tr>
        <tr class="noborder">
          <td align="right">运&nbsp;&nbsp;费：</td>
          <td>￥{{controlData.expressfee+" "+controlData.deliverymode}}</td>
          <td align="right">加工项：</td>
          <td><span style="color: red;font-size: larger"><b>{{seedname}}&nbsp;&nbsp;x{{sumnumber}}</b> </span><span style="color: red;font-size: larger" v-if="(printDisplay||!isprint)"><b>、 {{summoney}}元</b></span></td>
          <td align="right"></td>
          <td></td>
        </tr>
        <tr v-if="tableData.length>0">
          <td colspan="6" style="border:none">
            <table cellspacing="0" cellpadding="0" border="0" style="border-collapse:collapse;width:100%;" class="query-table">
              <tr>
                <td
                  v-if="item !='总价'&&item !='单价'&&item !='销售单号'" style="text-align: center;"
                  v-for="item in column">
                  {{item=='数量'?(item+'(片)'):item}}
                </td>
                <td v-if="(printDisplay)" style="text-align: center;">单价</td>
                <td v-if="(printDisplay)" style="text-align: center;">总价</td>
                <td style="text-align: center;">销售单号</td>
              </tr>
              <tr v-for="row in tableData">
                <td  v-if="item !='总价'&&item !='单价'&&item !='销售单号'" v-for="item in column" :style="{textAlign:item=='产品名称'?'left':'center',minWidth:item=='产品名称'?'90px':''}">
                  <div v-if="item=='球镜'">{{row[item]}}{{row['型号']}}</div>
                  <div v-if="item=='柱镜'">{{row[item]}}{{row['规格']}}</div>
                  <div v-if="!(item=='球镜'||item=='柱镜')">{{row[item]}}</div>
                  <div v-if="!isprint&&item=='产品名称'&&row['关联产品']" style="padding-left: 50px">{{row['关联产品']}}</div>
                </td>
                <td style="text-align: center;" v-if="(printDisplay)">{{parseFloat(row['单价']).toFixed(2)}}</td>
                <td style="text-align: center;" v-if="(printDisplay)">{{parseFloat(row['总价']).toFixed(2)}}</td>
                <td v-if="!isprint" style="width: 160px"> <div style="cursor: pointer" @click="getOpenOrder(row['销售单号'])">{{row['销售单号']}} {{row['订单状态']}}</div></td>
                <td v-else style="width: 140px">{{row['销售单号']}}</td>
              </tr>
            </table>
          </td>
        </tr>
        <tr class="noborder">
          <td align="right">说&nbsp;&nbsp;明：</td>
          <td colspan="5" style="border: none;height: 30px">
            <div v-html="getLiuYan(controlData.remark)">
            </div>
          </td>
        </tr>
        <tr class="noborder">
          <td colspan="5" style="border:none">
            <div style="float: left" v-for="(item,index) in formproperty" v-if="item">
              <span style="width:90px;display: inline-block;text-align: right">
              {{index+"："}}</span>
              <span style="width:70px;display: inline-block;text-align: left">{{item}}</span>
            </div>
          </td>
        </tr>
        <tr class="noborder" style="height: 26px">
          <td align="right">开单人：</td><td>{{controlData.ssfzr||''}}</td>
          <td align="right">加工师：</td><td><div  style="float: left;width: 140px">{{controlData.fileuname||''}}</div>
            <div style="padding-right: 15px;float: right;width: 140px">支付方式：{{controlData.paymethod||""}}</div></td>
          <td colspan="2">
            <span v-if="(printDisplay||!isprint)" style="font-size: larger">总额：<b>{{(parseFloat(summoney)+parseFloat(controlData.expressfee)).toFixed(2)}}</b>元</span>
            <span v-else>&nbsp;</span>
          </td>
        </tr>
        <tr class="noborder" style="height: 30px">
          <td colspan="6"></td>
        </tr>
        <tr class="noborder" style="height: 26px">
          <td align="right">服务商：</td>
          <td>{{controlData.servedname}}</td>
          <td align="right">地&nbsp;&nbsp;址：</td>
          <td>{{controlData.address}}</td>
          <td align="right">联系人：</td>
          <td>{{(controlData.elinkman||"")+" "+(controlData.elinkmantel||"")}}</td>
        </tr>
      </table>
    </div>
</template>


<script>

  import {machiningOrder} from '@/api/set/csagreement';
  import {getRemark} from '@/plugin/ordercommon'
  import RLTable from '@/components/set/goodsprice/RLTable';
  export default {
    name: 'CstagreementMachiningPrint',
    data() {
      return {
        loading: false,
        backimg: '',
        chufangdan: '',
        imgpath: '',
        showremark: false,
        dialogMachiningVisible: false,
        formLabelWidth: '120px',
        groupguid: '',
        seedcode: "",
        tableData: [],
        tableDatamap: [],
        unitguid: "",
        erpserial: '',
        column: [],
        controlData: {logisticsco: ""},
        seedname: '',
        formproperty: [],//  下部区域的参数
        count: 0,
        formpropertyData: [],
        sumnumber: '',
        summoney: '',
        handlelogData: [],//处理日期
        printDisplay: false,//是否显示单价和总价
        isprint: false,//控制价格显示
        showlookprice: false,//根据
        pagetitle: ''
      }
    },
    props: {
      batchprint: {
        default: false
      },
      issimple: {
        default: false
      }
    },
    methods: {
      getTitle(showname) {
        let result = [];
        if (showname && showname != '') {
          if (showname.indexOf(';') != -1) {
            var obj = showname.split(';')
            for (let i in obj) {
              if (obj[i] && i == 0) {
                result = obj[i]
              } else if (obj[i]) {
                result += ';' + obj[i]
              }
            }
          } else {
            result = showname
          }
        } else {
          let temp = localStorage.getItem("hpapi_userInfoModel")
          if (temp) {
            result += JSON.parse(temp).tenantname || ""
          }
        }
        if (result.indexOf(';') != -1) {
          var obj = result.split(';')
          for (let i in obj) {
            if (obj[i])
              obj[i] += "加工单"
          }
          result = obj.join(';')
        } else {
          result += "加工单"
        }
        return result
      },
      show() {
        this.dialogMachiningVisible = true;
      },
      contains(item, arr) {
        for (var i = 0; i < arr.length; i++) {
          if (arr[i] == item) {
            return true;
          }
        }
        return false;
      },
      getLiuYan(remark) {
        this.showremark = false;
        try {
          let temp = JSON.parse(remark.replace(/\r\n/g, "").replace(/\n/g, "").replace(/\r/g, "").replace(/\t/g, "  "))
          var s = ''
          temp.forEach(item => {
            if (item.type == '客户留言' && item.msg && item.msg != 'null') {
              s = item.msg;
            }
          })
          if (s)
            this.showremark = true;
          return s;
        } catch (ex) {
        }
      },
      //是否显示价格
      diaplayprice() {
        this.showlookprice = true;
      },
      initData(row,pagedata) {
        this.initForm()

        this.formpropertyData = []
        this.erpserial = row.erpserial
        this.groupguid = row.groupguid
        this.unitguid = row.unitguid
        this.status = row.status
        if (pagedata) {
          this.setPage(pagedata);
        } else {
          this.bindGrid()
        }
      },
      bindGrid() {
        machiningOrder({
          unitguid: this.unitguid,
          groupguid: this.groupguid,
          erpserial: this.erpserial
        }).then(response => {
           this.setPage(response.data.obj);
        });
      },
      setPage(objData){
        this.controlData = objData.detail;
        this.imgpath = window.API_ROOT + "/api/avatar/getBarcode?content=" + this.controlData.erpserial.substr(4)

        this.tableData =objData.goodsDetail;
        this.sumnumber = objData.sumnumber
        this.summoney = objData.summoney


        this.pagetitle = this.getTitle(objData.detail.printdname);
        this.seedname = objData.seedname;
        this.formproperty = objData.parameter;
        if (this.formproperty && this.formproperty['处方单']) {
          this.chufangdan = this.formproperty['处方单'];
          if (this.$refs.RLTable1)
            this.$refs.RLTable1.init(this.formproperty['处方单']);
        }
        this.printDisplay = true;
        this.isprint = true;

        this.tableDatamap = []

        if (this.tableData.length > 0) {
          let showrl = false
          var showzw = false;
          var showadd = false;
          var showtongd = false;
          for (let i in this.tableData) {
            for (let j in this.tableData[i]) {
              if (j == "R/L") {
                showrl = true;
              } else if (j == "轴位") {
                showzw = true;
              } else if (j == "ADD") {
                showadd = true;
              } else if (j == "通道") {
                showtongd = true;
              }
            }
          }
          this.column = []
          if (showrl)
            this.column.push("R/L")
          this.column.push("产品名称")
          this.column.push("球镜")
          this.column.push("柱镜")
          if (showzw)
            this.column.push("轴位")
          if (showadd)
            this.column.push("ADD")
          if (showtongd)
            this.column.push("通道")
          this.column.push("销售单号")
          this.column.push("数量")
          if (this.printDisplay || this.showlookprice) {//需要打印价格的才加载单价
            this.column.push("单价")
            this.column.push("总价")
          }
        }
      },
      initForm() {
        this.diaplayprice();
        this.chufangdan = '';
        if (this.$refs.RLTable1)
          this.$refs.RLTable1.reset();
        this.loading = false;
        this.backimg = '';
        this.groupguid = ""
        this.column = []
        this.tableData = []
        this.unitguid = "";
        this.uname = '';
        this.adddate = '';
        this.printDisplay = false
      },
    },
    mounted() {
    },
    components: {
      RLTable
    }
  }
</script>

<style scoped>
  .query-table td {
    border: 1px solid #E0DFDF;
    vertical-align: center;
    height: 22px;
    line-height: 16px;
    padding: 2px;
    font-size: 12px;
  }

  .query-table td.content {
    text-align: center;
  }

  .noborder td {
    border: none;
    font-size: 12px;
  }


</style>





// WEBPACK FOOTER //
// src/components/testorder/cstagreement/CstagreementMachiningPrint.vue